import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import Layout from "layouts/views/components/Layout";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getPickFaceLocation,
  deleteLocationForPickFace,
  deletePickFaceDetail
} from "services/data.internal.service";
import { DialogAlert } from "layouts/views/components/Alert";

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RemovePickFaceLocationInfo from "./components/RemovePickFaceLocationInfo";
import { Success,Error } from "ui-components/Alert";
import { InboundLayout } from "ui-components/Layout";
import { InboundSaveButton } from "ui-components/Form";
import { Error_ } from "ui-components/Alert";
import { editPickFaceLocation } from "services/data.internal.service";
function RemovePickFaceLocation() {
  const location = useLocation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { warehouseCode, zoneID, rack } = location?.state ?? {};
  const [alert, setAlert] = useState(null);
  // const [locId, setLocId] = useState([]);
  // const [selectedLocation, setSelectedLocation] = useState(null);

  const [detail, setDetail] = useState([]);

  const { isLoading } = useQuery({
    queryKey: ["pick-face-location", [warehouseCode, zoneID, rack]],
    queryFn: () =>
      getPickFaceLocation({ warehouseCode: warehouseCode, zoneID: zoneID, rack: rack }),
    refetchOnWindowFocus: false,
    enabled: warehouseCode !== undefined && zoneID !== undefined && rack !== undefined,
    onSuccess: (data) => {
      const { pickFaceLocationDetails, ...remainingData } = data.data.data;
      setDetail(pickFaceLocationDetails.map(x => {
        return {
          id: `${x.locationId}_${x.customerCode}_${x.vendorCode}_${x.skuCode}`,
          ...x
        }
      }));
      // const locationItemsList = [];

      // pickFaceLocationDetails.forEach((detail) => {
      //   const { locationId, skuCode, customerCode, vendorCode, routeSequence } = detail;

      //   const locationIndex = locationItemsList.findIndex((data) => data.locationID === locationId);
      //   if (locationIndex === -1) {
      //     locationItemsList.push({
      //       locationID: locationId,
      //       skus: [{ skuCode, customerCode, vendorCode, routeSequence }],
      //     });
      //   } else {
      //     locationItemsList[locationIndex].skus.push({
      //       skuCode,
      //       customerCode,
      //       vendorCode,
      //       routeSequence,
      //     });
      //   }
      // });

      // locationItemsList.sort((a, b) => a.locationID.localeCompare(b.locationID));

      // setLocId(locationItemsList);
    },
    onError: (data) => {
      setAlert(<Error content={data.response.data} onChange={setAlert} />);
    },
  });

  // const deleteLocationFromPickFaceMutation = useMutation(deleteLocationForPickFace, {
  //   onSuccess: (data) => {
  //     queryClient.invalidateQueries(["pick-face-location"]);
  //     setAlert(<Success content={data.data.message} onChange={setAlert}/>);
  //     setSelectedLocation(null);
  //   },
  //   onError: (data) => {
  //     setAlert(<Error content={data.response.data.message} onChange={setAlert}/>);
  //   },
  // });

  const deletePickFaceLocationDetailMutation = useMutation(deletePickFaceDetail, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["pick-face-location"]);
      setAlert(<Success content={data.data.message} onChange={setAlert} />);
      // setSelectedLocation(null);
    },
    onError: (data) => {
      setAlert(<Error content={data.response.data.message} onChange={setAlert} />);
    },
  });

  const editPickFaceMutation = useMutation(editPickFaceLocation, {});

  const [dialog, setDialog] = useState(null);
  const handleDel = (req) => {
    window.scrollTo(0, 0);
    if (alert !== null) {
      setAlert(null);
    }
    if (req.mode === "detail") {
      //call delLoc
      const { locationID, customerCode, vendorCode, skuCode } = req;
      deletePickFaceLocationDetailMutation.mutate(
        {
          warehouseCode: warehouseCode,
          zoneID: zoneID,
          rack: rack,
          req: {
            locationIDs: locationID,
            customerCode: customerCode,
            vendorCode: vendorCode,
            skuCode: skuCode,
          },
        },
        {
          onSuccess: () => {
            // setSelectedLocation(null);
          },
        }
      );
    }
    // else if (req.mode === "location"){
    //   const { locationID } = req;
    //   deleteLocationFromPickFaceMutation.mutate({
    //     warehouseCode: warehouseCode,
    //       zoneID: zoneID,
    //       rack: rack,
    //       req: {
    //         locationIDs: locationID
    //       }
    //   })
    // }
  };
  const handleOk = (req) => {
    handleDel(req);
    setDialog(null);
  };
  const handleClose = () => {
    setDialog(null);
  };
  const renderDialog = (req) => {
    let dialog;
    if (req.locationID === null || req.locationID === "") {
      setAlert(<Error content={"Invalid Location ID"} onChange={setAlert} />);
      window.scrollTo(0, 0);
      return;
    }
    // if (req.mode === "location") dialog = `Delete Location ${req.locationID}`;
    // else {
      let customer, vendor, sku;
      if (req.customerCode === null || req.customerCode === "") customer = "all customer";
      else customer = req.customerCode;
      if (req.vendorCode === null || req.vendorCode === "") vendor = "all vendor";
      else vendor = req.vendor;
      if (req.skuCode === null || req.skuCode === "") sku = "all sku";
      else sku = req.skuCode;
      dialog = `Delete detail of ${customer} - ${vendor} - ${sku}`;
    // }
    setDialog(
      <DialogAlert
        open={true}
        title={dialog}
        onClose={handleClose}
        onOk={() => {
          handleOk(req);
        }}
      />
    );
  };

  const onSubmit = async () => {
    window.scrollTo(0, 0);

    if (detail.some(x => (x.qtyToReplenish !== null && x.uomType === null) || (x.qtyToReplenish === null && x.uomType !== null)))
    {
      setAlert(<Error_ content={"Invalid Selection, Quantity To Replenish Must Select UOM Type"} onChange={setAlert} />);
      return;
    }

    const req = {
      detail
    };

    editPickFaceMutation.mutate(
      { warehouseCode, zoneID, rack, req },
      {
        onSuccess: (data) => navigate("/setup/pickface-location", { state: data.data.message }),
        onError: (data) => setAlert(<Error_ data={data} onChange={setAlert} />),
      }
    );
  };

  return (
    <InboundLayout lg={12}>
      {alert}
      {dialog}
      {isLoading ? (
        <>
          <p>Loading...</p>
        </>
      ) : (
        <MDBox>
          <Card sx={{ height: "100%" }}>
            <MDBox p={3}>
              <RemovePickFaceLocationInfo
                warehouseCode={warehouseCode}
                zoneID={zoneID}
                rack={rack}
                // locationsId={locId}
                renderDialog={renderDialog}
                // selectedLocation={selectedLocation}
                // setSelectedLocation={setSelectedLocation}
                detail={detail}
                setDetail={setDetail}
                setAlert={setAlert}
              />
            </MDBox>
          </Card>
          <InboundSaveButton
            url="/setup/pickface-location"
            onClick={onSubmit}
            disabled={detail.length === 0}
          />
        </MDBox>
      )}
    </InboundLayout>
  );
}

export default RemovePickFaceLocation